import { render, staticRenderFns } from "./DownloadDesktop.vue?vue&type=template&id=b0e78c08&scoped=true&"
import script from "./DownloadDesktop.vue?vue&type=script&lang=js&"
export * from "./DownloadDesktop.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDesktop.css?vue&type=style&index=0&id=b0e78c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e78c08",
  null
  
)

export default component.exports